<template>
  <nav
    class="menu self-service-menu v-self-service-menu"
  >
    <el-menu
      :key="projectId"
      :background="'nav-primary'"
      class="rootmenu"
      :collapse="collapsed"
      :default-active="activeMenu"
      :default-openeds="[activeMenu]"
      :router="true"
    >
      <template v-if="isDomainMode">
        <el-menu-item
          key="/users"
          data-testid="menu-item-users"
          index="/users"
        >
          <template #icon>
            <el-icon
              name="i-users-o--24"
            ></el-icon>
          </template>
          <template #title>
            {{ $t('USERS') }}
          </template>
        </el-menu-item>

        <el-menu-item
          key="/projects"
          data-testid="menu-item-projects"
          index="/projects"
        >
          <template #icon>
            <el-icon
              name="i-case-o--24"
            ></el-icon>
          </template>
          <template #title>
            {{ $t('PROJECTS') }}
          </template>
        </el-menu-item>

        <el-menu-item
          key="/api-credentials-all"
          data-testid="menu-item-api-credentials-all"
          index="/api-credentials-all"
        >
          <template #icon>
            <el-icon
              name="i-key-o--24"
            ></el-icon>
          </template>
          <template #title>
            {{ $t('API CREDENTIALS') }}
          </template>
        </el-menu-item>
      </template>

      <template v-else>
        <el-menu-item
          v-if="showMonitoring"
          key="/monitoring"
          data-testid="menu-item-monitoring"
          index="/monitoring"
        >
          <template #icon>
            <el-icon
              name="i-heartbeat-o--24"
            ></el-icon>
          </template>
          <template #title>
            {{ $t('MONITORING') }}
          </template>
        </el-menu-item>

        <el-menu-item
          v-if="isComputeConfigured"
          key="/compute"
          data-testid="menu-item-compute"
          index="/compute"
        >
          <template #icon>
            <el-icon
              name="i-virtual-machines-o--24"
            ></el-icon>
          </template>
          <template #title>
            {{ $t('COMPUTE') }}
          </template>
        </el-menu-item>

        <el-menu-item
          v-if="showS3Menus"
          key="/s3-storage"
          data-testid="menu-item-s3"
          index="/s3-storage"
        >
          <template #icon>
            <el-icon name="i-subroot-o--24" />
          </template>
          <template #title>
            {{ $t('S3') }}
          </template>
        </el-menu-item>

        <el-menu-item
          v-if="isComputeConfigured"
          key="/settings"
          data-testid="menu-item-settings"
          index="/settings"
        >
          <template #icon>
            <el-icon
              name="i-settings-o--24"
            ></el-icon>
          </template>
          <template #title>
            {{ $t('SETTINGS') }}
          </template>
        </el-menu-item>
      </template>
    </el-menu>
  </nav>
</template>

<script>
  import useAuthStore from '@/common/store/pinia/auth';
  import useS3ServiceStore from '@/common/store/pinia/s3Service';
  import useS3BucketsStore from '@/common/store/pinia/s3Buckets';
  import { mapState, mapStores } from 'pinia';

  export default {
    name: 'SelfServiceMenu',
    props: {
      collapsed: Boolean
    },
    created() {
      this.$store.dispatch('compute/FETCH_COMPUTE_CLUSTER');
    },
    computed: {
      ...mapState(useAuthStore, {
        isDomainMode: 'domainMode',
        projectId: 'currentProject',
        currentUser: 'currentUser',
        isProjectAdmin: 'isProjectAdmin'
      }),
      ...mapStores(useS3ServiceStore, useS3BucketsStore),
      activeMenu() {
        return this.$route.matched[0] && this.$route.matched[0].path;
      },
      isComputeConfigured() {
        return this.$store.getters['compute/isComputeConfigured'];
      },
      showS3Menus() {
        return this.s3BucketsStore.isS3Available && this.isProjectAdmin;
      },
      showMonitoring() {
        return this.isComputeConfigured || (this.showS3Menus && !this.s3ServiceStore.isLegacyS3User);
      },
    },
    watch: {
      projectId: {
        immediate: true,
        handler() {
          if (!this.projectId) {
            return;
          }
          const loadBuckets = () => this.s3BucketsStore.fetchBuckets();
          this.s3ServiceStore.getS3Service().then(loadBuckets, loadBuckets);
        }
      },
      isDomainMode: {
        handler(newVal, oldVal) {
          if (!newVal && oldVal && this.currentUser) {
            this.$router.replace({ name: 'monitoring' });
          }
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  .menu {
    display: flex;
    height: 100%;
  }

  .rootmenu {
    height: 100%;
    min-width: 64px;

    .el-menu-item {
      display: flex;
      justify-content: center;
    }
  }

  ::v-deep .el-menu--vertical.el-menu--secondary {
    .el-menu-item,
    .el-menu__bar--level-2 .el-menu-item {
      padding-left: 64px;
      height: 32px;
      color: $av-fixed-primary;

      &.is-root {
        height: 32px;
      }

      &.is-active {
        background-color: $av-brand-lighter;
        color: rgb(0, 101, 227);

        .el-text {
          font-weight: $av-font-weight-bold;
        }
      }
    }

    .el-menu__bar > li {
      border-top: 0;
    }
  }
</style>
